const DEFAULT_FETCH_TIMEOUT_MS = 10000;

export const fetchWithTimeout = async (url, options = {}, timeoutMs = DEFAULT_FETCH_TIMEOUT_MS) => {
  const controller = new AbortController();
  const externalSignal = options.signal;
  let didTimeout = false;

  if (externalSignal?.aborted) {
    throw new DOMException('Request aborted', 'AbortError');
  }

  const abortRequest = () => controller.abort();
  if (externalSignal) {
    externalSignal.addEventListener('abort', abortRequest, { once: true });
  }

  const timeoutId = window.setTimeout(() => {
    didTimeout = true;
    controller.abort();
  }, timeoutMs);

  try {
    return await fetch(url, {
      ...options,
      signal: controller.signal,
    });
  } catch (error) {
    if (didTimeout && error?.name === 'AbortError') {
      throw new DOMException(`Request timed out after ${timeoutMs}ms`, 'TimeoutError');
    }
    throw error;
  } finally {
    window.clearTimeout(timeoutId);
    if (externalSignal) {
      externalSignal.removeEventListener('abort', abortRequest);
    }
  }
};

export default fetchWithTimeout;
